import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {
  navId = new BehaviorSubject<string>(null);
  childNavId = new BehaviorSubject<string>(null);
  platformId = inject(PLATFORM_ID);
  canClose = new BehaviorSubject<boolean>(false);
  currentLang = isPlatformBrowser(this.platformId) ? window.localStorage.getItem('spartacus⚿⚿language') : '';

  myAccount$: Observable<any> = this.http.get(this.occService.buildUrl(`myaccount/getnavnodes?`)).pipe(shareReplay(1));

  constructor(private http: HttpClient,
    private occService: OccEndpointsService) {
  }


  getLeftSideNavMyAccountApi() {
    return this.myAccount$;
  }
  getLeftSideNavMyAccountApiLangChange() {
    return this.http.get(this.occService.buildUrl(`myaccount/getnavnodes?`));
  }

  checkifAccountDisabled(email: string) {
    const params = new HttpParams().set('email', email);
    return this.http.get(this.occService.buildUrl('/kbhomepage/checkifAccountDisabled'),
      { params });
  }
}
